import React, { Component } from "react";

import { Access, PermissionsEnum } from "common";
import { Breadcrumbs, Navigation, Page } from "components";

class Main extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "PRO", to: "/pro" },
    ],
    navigation: [
      {
        name: "Listagem de Clientes PRO",
        to: "/pro/list",
        hidden: !Access.hasPermissions([
          "manage-inhabitant-segments",
          "view-inhabitant-segments",
        ]),
      },
      {
        name: "Listagem de Cashbacks",
        to: "/pro/cashback/list",
        hidden: !Access.hasPermissions([
          "view-cashback-imports",
          "manage-cashback-imports",
        ]),
      },
      {
        name: "Listagem de Cashbacks Automáticos",
        to: "/pro/cashback/automatic/list",
        hidden: !Access.hasPermissions([
          "view-cashback-imports",
          "manage-cashback-imports",
        ]),
      },
      {
        name: "Transferência Carteira Clientes",
        to: "/pro/transfer-wallet",
        hidden: !Access.hasPermissions([
          PermissionsEnum.MANAGE_CASHBACK_IMPORTS,
        ]),
      },
    ],
  };

  render() {
    const { breadcrumbs, navigation } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <Navigation items={navigation} />
      </Page>
    );
  }
}

export default Main;
